module.exports = "{{#Children}}\r\n    <li class=\"level{{Level}} {{#Strong}}strong{{/Strong}}\">\r\n        <a class=\"document-link category-title\" data-document-id=\"{{Key}}\" href=\"category/{{FriendlyUrlTitle}}/leading-cases/{{Key}}\">{{Name}}</a>\r\n        <ul class=\"category-block\">\r\n            {{>recursive_category}}\r\n        </ul>\r\n    </li>\r\n{{/Children}}"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/partials/recursive-category.html
// module id = 353
// module chunks = 1